import React from "react";

// Category filters (filter the shop grid + scroll to shop)
const CATS = [
  { id: "ghee", label: "Ghee" },
  { id: "milk", label: "Milk" },
  { id: "makhan", label: "Makhan" },
  { id: "oil", label: "Oil" },
  { id: "vegetables", label: "Vegetables" },
  { id: "mushroom", label: "Mushroom" },
  { id: "spices", label: "Spices" },
  { id: "seeds", label: "Seeds" },
  { id: "aata", label: "Aata" },
  { id: "dryfruits", label: "Dry Fruits" },
  { id: "coconut", label: "Coconut" },
  { id: "aachar", label: "Aachar" },
  { id: "tea", label: "Tea" },
  { id: "rajasthani", label: "Rajasthani Dry Veg" },
  { id: "laddu", label: "Laddu" },
];

// Section links (just scroll to section)
const LINKS = [
  { id: "wallet", label: "Wallet" },
  { id: "contact", label: "Contact" },
];

// External auth links (route to login page)
const AUTH_LINKS = [
  { path: "/admin/login", label: "Admin" },
  { path: "/agent/login", label: "Agent" },
];

export const CategoryNav = () => {
  const pickCategory = (cat) => {
    window.dispatchEvent(new CustomEvent("set-category", { detail: cat }));
    const el = document.getElementById("shop");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="category-nav"
      className="fixed top-16 md:top-20 left-0 right-0 z-30 bg-background/85 backdrop-blur-md border-b border-border"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-12 flex items-center gap-1 overflow-x-auto scrollbar-hide">
        {CATS.map((c) => (
          <button
            key={c.id}
            data-testid={`topnav-cat-${c.id}`}
            onClick={() => pickCategory(c.id)}
            className="shrink-0 px-4 py-1.5 rounded-full text-xs md:text-sm font-medium tracking-wide text-foreground/75 hover:text-accent-foreground hover:bg-accent transition-colors"
          >
            {c.label}
          </button>
        ))}
        <span className="shrink-0 mx-2 h-5 w-px bg-border" />
        {LINKS.map((l) => (
          <button
            key={l.id}
            data-testid={`topnav-link-${l.id}`}
            onClick={() => scrollTo(l.id)}
            className="shrink-0 px-4 py-1.5 rounded-full text-xs md:text-sm font-medium tracking-wide text-foreground/75 hover:text-accent-foreground hover:bg-accent transition-colors"
          >
            {l.label}
          </button>
        ))}
        <span className="shrink-0 mx-2 h-5 w-px bg-border" />
        {AUTH_LINKS.map((l) => (
          <a
            key={l.path}
            href={l.path}
            data-testid={`topnav-auth-${l.label.toLowerCase()}`}
            className="shrink-0 px-4 py-1.5 rounded-full text-xs md:text-sm font-medium tracking-wide text-primary border border-primary/30 hover:bg-primary hover:text-primary-foreground transition-colors"
          >
            {l.label}
          </a>
        ))}
      </div>
    </div>
  );
};
